export default (label, max = 255) => ({
  max,
  type: 'string',
  message: `The ${label} field can only be up to ${max} characters.`,
  trigger: 'blur',
})
